export default () => ({
    fields: [],
    stepNum: 1,
    typeOfPrevDocument: '',
    refs: [],
    actionsButton: [],
    activeCheckBox: [],
    creativeET: [],
    campuses: [],
    birthDate: '',
    formViewMode: 'default',
    isInitFields: false,
    isChangedForm: false,
    messagesFields: {
        // [key: stepNumber]: message
    },
    requiredSteps: [1, 2, 3, 6, 14, 15, 19], // by default
    codesWhenUpdate: [
        'OLYMPIAD_LIST_YEAR',
        'OLYMPIAD_LIST_PROFILE',
        'OLYMPIAD_LIST_OLYMPIAD',
        'OLYMPIAD_RU_YEAR',
        'OLYMPIAD_RU_PROFILE',
        'OLYMPIAD_INTERNATIONAL_YEAR',
        'OLYMPIAD_UKR_YEAR',
        'EDUCATION_LEVEL',
        'ACHIEVEMENT_CATHEGORY',
        'TARGETED_DIRECTION'
    ],
    typeOfDocument: '',
    registrationCountry: '',
    residencyCountry: '',
    example: {},
    competitionGroupList: [],
    savedFiles: {},
    selectedCompetitionGroup: [],
    selectedCompetitionGroupGUID: [],
    data: {},
    residencyFill: false,
    competitiveGroups: [],
    selectedBwe: null,
    selectedOlympic: null,
    userId: null,
    validationErrors: [],
    triggerProgram: false,
    status: {
        step_1: 'default',
        step_2: 'default',
        step_3: 'default',
        step_4: 'default',
        step_5: 'default',
        step_6: 'default',
        step_7: 'default',
        step_8: 'default',
        step_9: 'default',
        step_10: 'default',
        step_11: 'default',
        step_12: 'default',
        step_13: 'default',
        step_14: 'default',
        step_15: 'default',
        step_16: 'default',
        step_17: 'default',
        step_18: 'default',
        step_19: 'default',
    },

    guidRf: '',  // GUID РФ
    guidDocumentsRf: '', // GUID документы РФ
    guidPassportRf: '', // GUID паспорт РФ
    guidBlr: '',// GUID Беларусь
    guidForeignDocTyp: '', // GUID Вид документа инностранного государста
    guidIsHseEducationLevel: '', // GUID Уровень образования ВШЭ
    guidIsHseEducationCountry: '', // GUID Страна образования ВШЭ
    guidIsHseEducationDocType: '',// GUID Тип документа об образовании ВШЭ
    guidIsHseEducationRegion: '', // GUID Регион образования ВШЭ
    guidIsHseEducationOrgType: '', // GUID Тип образовательной организации ВШЭ
    guidIsHseEducationCity: '', // Город организации ВШЕ
    guidIsHseEducationOrgName: '', // Название организации ВШЕ    
    guidBenefitTypes: { // Особая квота: Льготы BENEFIT_TYPE
        orphanage: [], // Детсик дом
        disability: [], // Инвалидность
        combanant: [], // ?
    },
    guidEducationDocTypes: [], // Вид документа об образовании EDUCATION_DOCUMENT_TYPE шаг 5
    guidExtraQuotaType: 'empty', // GUID Тип отдельная квота(extra_quota) конкурсной группы
})
